<template>
<div class="chapter">
<div class="inner_page">
<div class="part font-AtmaSerif-MediumRoman-5_1-12"><a id="p8">
<div class="image_wrap color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"><div class="illustype_image_text_net"> <img alt="e9780811866989_i0002.jpg" src="images/e9780811866989_i0002.jpg"/></div>
<p class="caption"><span class="color-FF5100"><span class="font-Goudy-HeavyfaceItalic-1_1-8_5">Fig. 1: </span></span><span class="color-3C1C00"><span class="font-AtmaSerif-MediumItalic-6_1-12">The Charcoal Grill</span></span></p></div></a></div><a id="p8">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005part01.vue?203e87dc